<template>
  <a-layout class="my-application-box">
    <a-card class="create-application" :bordered=false :loading="loading">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <div slot="extra" style="cursor:pointer" v-if="pageLayout.introduction">
        <span @click="introductionVisible=true">
          <a-icon type="exclamation-circle" />{{pageLayout.introduction.title}}</span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="!loading && loadedInfo">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange" @update="update"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" :need-id="true" :default-params="defaultParams" @changed-fields="onFieldChange" @update="update"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="!loading && loadedInfo"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row style="margin:30px 0 24px;" v-if="!loading && loadedInfo">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" :disabled="!canSubmit" @click="submit" style="width:120px;margin-right:18px;">提交</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <a-modal class="introductionModal" :title="pageLayout.introduction.title" v-if="pageLayout.introduction" v-model="introductionVisible" @ok="introductionVisible=false" :okText="'关闭'">
        <div>
          <pre style="font-size: 14px;color: rgba(0,0,0,0.65);line-height: 22px;text-align:left">{{pageLayout.introduction.description}}</pre>
        </div>
      </a-modal>
      <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcAll from "../../assets/svg/ic-all-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  getLayoutApi,
  getPaymentDetail,
  createPayment,
  getApprovalFlow,
  sendComment
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload
  },
  data() {
    return {
      introductionVisible: false,
      canSubmit: true,
      canEdit: true,
      breadcrumb: [
        {
          label: "发起申请",
          path: ""
        }
      ],
      cardHeight: 0,
      applicationTitle: "发起付款申请",
      params: {},
      defaultParams: {},
      loading: false,
      loadedInfo: false,
      pageLayout: {},
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
      visibleComment: false
    };
  },

  created() {
    this.fetchLayout();
    this.getPaymentDetail();
    this.getPaymentDefaultInfo();
  },
  mounted() {},

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          type: this.requestParams.basicInfo.type,
          company_id: this.requestParams.basicInfo.company_id,
          total_pay: this.requestParams.total_pay
        };
      }
    }
  },

  methods: {
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        {},
        this.requestParams,
        this.summationInfo
      );
    },
    fetchLayout() {
      this.loading = true;
      getLayoutApi({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loading = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getApprovalFlow(this.requestParams, this).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPaymentDetail() {
      getPaymentDetail({
        type: this.$route.query.type,
        id: this.$route.query.id
      }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          LayoutConfig.setAllParams(this.params);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPaymentDefaultInfo() {
      getPaymentDetail({
        type: "default"
      }).then(res => {
        if (res.status === "success") {
          this.defaultParams = Object.assign({}, this.defaultParams, res.data);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submit() {
      let validateResult = true;
      this.$refs.commonForm.forEach(item => {
        if (!item.validateFields()) {
          validateResult = false;
        }
      });
      this.$refs.multiForm.forEach(item => {
        if (!item.validateFields()) {
          validateResult = false;
        }
      });
      if (validateResult) {
        this.canSubmit = false;
        createPayment(this.requestParams).then(res => {
          if (res.status === "success") {
            this.$Message.success("修改申请成功");
            this.$router.replace({
              name: "myApplicationList"
            });
          } else {
            this.$Message.error(h =>
              h("span", {
                domProps: {
                  innerHTML: res.message
                }
              })
            );
          }
          this.canSubmit = true;
        });
      }
    },
    update(e) {
      this.fetchLayout();
    },
    back() {
      this.$router.replace({
        name: "launchApplication"
      });
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.type &&
          val.company_id &&
          val.total_pay &&
          val.total_pay !== "0.00"
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
.my-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
